import React from "react";
import "./AltarImage.css";

export default function AltarImage(props) {
  return (
    <div>
      {props.imageType === 1 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/SwSjwZt.png"
          alt="flower1"
        />
      ) : null}

      {props.imageType === 2 ? (
        <img src="https://i.imgur.com/iRGDCuu.png" alt="buddha" />
      ) : null}

      {props.imageType === 3 ? (
        <img src="https://i.imgur.com/Oko2TUp.png" alt="candle1" />
      ) : null}

      {props.imageType === 4 ? (
        <img src="https://i.imgur.com/5pHBSWA.png" alt="calavera1" />
      ) : null}

      {props.imageType === 5 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/t0Lbcf2.png"
          alt="bowl1"
        />
      ) : null}

      {props.imageType === 6 ? (
        <img
          className="w-64"
          src="https://i.imgur.com/gGlBwh3.png"
          alt="led1"
        />
      ) : null}

      {props.imageType === 7 ? (
        <img
          className="w-44"
          src="https://i.imgur.com/MVdrXT9.png"
          alt="led2"
        />
      ) : null}

      {props.imageType === 8 ? (
        <img src="https://i.imgur.com/xe2MhVj.png" alt="fruit1" />
      ) : null}

      {props.imageType === 9 ? (
        <img src="https://i.imgur.com/TUNNl7v.png" alt="flower2" />
      ) : null}

      {props.imageType === 10 ? (
        <img src="https://i.imgur.com/Gw6tHOA.png" alt="crystals1" />
      ) : null}

      {props.imageType === 11 ? (
        <img src="https://i.imgur.com/1O6Dyg3.png" alt="ganesha1" />
      ) : null}

      {props.imageType === 12 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/kInduau.png"
          alt="candle2"
        />
      ) : null}

      {props.imageType === 13 ? (
        <img
          className="w-32"
          src="https://i.imgur.com/VJ2pXzU.png"
          alt="sage1"
        />
      ) : null}

      {props.imageType === 14 ? (
        <img
          className="w-40"
          src="https://i.imgur.com/kFFDKji.png"
          alt="book1"
        />
      ) : null}

      {props.imageType === 15 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/8AjKLn4.png"
          alt="cactus1"
        />
      ) : null}

      {props.imageType === 16 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/Q3cjvqp.png"
          alt="cup1"
        />
      ) : null}

      {props.imageType === 17 ? (
        <img
          className="w-44"
          src="https://i.imgur.com/hkIetv9.png"
          alt="combo1"
        />
      ) : null}

      {props.imageType === 18 ? (
        <img
          className="w-20"
          src="https://i.imgur.com/c1QwUaA.png"
          alt="helloluckycat"
        />
      ) : null}

      {props.imageType === 19 ? (
        <img
          className="w-32"
          src="https://i.imgur.com/f0A81Bs.png"
          alt="candleholder"
        />
      ) : null}

      {props.imageType === 20 ? (
        <img
          className="w-32"
          src="https://i.imgur.com/s9l4lQH.png"
          alt="medicinewheel"
        />
      ) : null}

      {props.imageType === 21 ? (
        <img
          className="w-16"
          src="https://i.imgur.com/yDk2ljO.png"
          alt="salt"
        />
      ) : null}

      {props.imageType === 22 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/zj86Arn.png"
          alt="pyramid"
        />
      ) : null}

      {props.imageType === 23 ? (
        <img
          className="w-32"
          src="https://i.imgur.com/YYE0doj.png"
          alt="flowercandles"
        />
      ) : null}

      {props.imageType === 24 ? (
        <img
          className="w-32"
          src="https://i.imgur.com/7Orii6Q.png"
          alt="plantinpot"
        />
      ) : null}

      {props.imageType === 25 ? (
        <img
          className="w-44"
          src="https://i.imgur.com/tpOEPdX.png"
          alt="fruitbasket"
        />
      ) : null}

      {props.imageType === 26 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/vluZCWU.png"
          alt="calavera2"
        />
      ) : null}

      {props.imageType === 27 ? (
        <img
          className="w-32"
          src="https://i.imgur.com/UVXDBy8.png"
          alt="kaaba"
        />
      ) : null}

      {props.imageType === 28 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/tlwB5V9.png"
          alt="menorah"
        />
      ) : null}

      {props.imageType === 29 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/4hB8qj4.png"
          alt="stardavid"
        />
      ) : null}

      {props.imageType === 30 ? (
        <img
          className="w-32"
          src="https://i.imgur.com/MBivzfO.png"
          alt="cross"
        />
      ) : null}

      {props.imageType === 31 ? (
        <img
          className="w-32"
          src="https://i.imgur.com/cxWU7M3.png"
          alt="pothos"
        />
      ) : null}

      {props.imageType === 32 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/f6X9azp.png"
          alt="cactus2"
        />
      ) : null}

      {props.imageType === 33 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/YBQoAcR.png"
          alt="flowers2"
        />
      ) : null}

      {props.imageType === 34 ? (
        <img
          className="w-20"
          src="https://i.imgur.com/JAR3AGZ.png"
          alt="flowers3"
        />
      ) : null}

      {props.imageType === 35 ? (
        <img
          className="w-36"
          src="https://i.imgur.com/g6uTFsh.png"
          alt="seashell"
        />
      ) : null}

      {props.imageType === 36 ? (
        <img
          className="w-40"
          src="https://i.imgur.com/fIhU0Dm.png"
          alt="goddess-isis"
        />
      ) : null}

      {props.imageType === 37 ? (
        <img
          className="w-40"
          src="https://i.imgur.com/xWeN9M3.png"
          alt="floraloffering"
        />
      ) : null}

      {props.imageType === 38 ? (
        <img
          className="w-20"
          src="https://i.imgur.com/AtqHOs8.png"
          alt="hojaldra"
        />
      ) : null}

      {props.imageType === 39 ? (
        <img
          className="w-64"
          src="https://i.imgur.com/p8ItQzs.png"
          alt="moneyoffering"
        />
      ) : null}

      {props.imageType === 40 ? (
        <img
          className="w-32"
          src="https://i.imgur.com/CIli1Rt.png"
          alt="flowerpetals"
        />
      ) : null}

      {props.imageType === 41 ? (
        <img
          className="w-32"
          src="https://i.imgur.com/sKfC5ZU.png"
          alt="totempole"
        />
      ) : null}

      {props.imageType === 42 ? (
        <img
          className="w-30"
          src="https://i.imgur.com/s8bJxPb.png"
          alt="cathedral"
        />
      ) : null}

      {props.imageType === 43 ? (
        <img
          className="w-30"
          src="https://i.imgur.com/anE6ZSl.png"
          alt="angel"
        />
      ) : null}

      {props.imageType === 44 ? (
        <img
          className="w-64"
          src="https://i.imgur.com/s0mBLl4.png"
          alt="rug"
        />
      ) : null}
      
      {props.imageType === 45 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/cPvzJ2o.png"
          alt="flower3"
        />
      ) : null}

      {props.imageType === 46 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/5qQD8Fd.png"
          alt="sunflower"
        />
      ) : null}

      
      {props.imageType === 47 ? (
        <img
          className="w-24"
          src="https://i.imgur.com/n1jVOf5.png"
          alt="flower4"
        />
      ) : null}


    </div>
  );
}
